import React from 'react';
import "./index.css";

export default class ModalImage extends React.Component {
    state = {
        modalId: ""
    }
    constructor(){
        super();
    }

    componentDidMount(){

        const {imageQuerySelector} = this.props;
        this.setState({
            modalId: "modal_"+parseInt(Math.random()*1e10)+""
        })

        setTimeout(()=>{
            // Get the modal
            const {modalId} = this.state;
            var modal = document.getElementById(modalId);

            // Get the image and insert it inside the modal - use its "alt" text as a caption
            var img = document.querySelector(imageQuerySelector);
            console.log({
                imageQuerySelector, img, modal, modalId
            });
            var modalImg = modal.getElementsByClassName("img01");
            var captionText = modal.getElementsByClassName("caption");
            this.setState({
                modalImg: img.src
            })

            img.onclick = function(){
                modal.style.display = "block";
                modalImg.src = this.src;
                captionText.innerHTML = this.alt;
            }

            // Get the <span> element that closes the modal
            var span = modal.getElementsByClassName("close")[0];

            // When the user clicks on <span> (x), close the modal
            span.onclick = function() {
                modal.style.display = "none";
            }
            
        }, 1500);
    }


    render(){
        const {modalId, modalImg} = this.state;

        return (
            <div id={modalId} className="modal">

                <span className="close">&times;</span>

                <img src={modalImg} className="modal-content" className="img01"/>

                <div className="caption"></div>
            </div>
        )
    }
}